'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reveiveConfig = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _pcSlateTools = require('@process-creative/pc-slate-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reveiveConfig = exports.reveiveConfig = function reveiveConfig() {
  var config = {
    partner_id: 'CCi44GatWw',
    locale: 'en',
    env: 'prod', // for test env. Change to prod for production deployment
    onAddToCart: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(products) {
        var revieveProducts, query, skus;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Add to cart functionality for revieve app
                revieveProducts = Array.isArray(products) ? products : [products];
                query = revieveProducts.map(function (p) {
                  return 'variants.sku:' + p.id;
                }).join(' OR ');
                skus = revieveProducts.map(function (p) {
                  return p.id;
                }).filter(function (f) {
                  return f;
                });

                // Match revieve product data with Shopify products

                _context.next = 5;
                return (0, _pcSlateTools.shopifyGet)('/search', { view: 'sku-lookup', q: query }).then(function (res) {
                  var variantIds = res.map(function (p) {
                    return p.variants.find(function (v) {
                      return skus.indexOf(v.sku) != -1;
                    }).id;
                  }).filter(function (f) {
                    return f;
                  });
                  variantIds.forEach(function (v) {
                    return (0, _pcSlateTools.addToCart)(v);
                  });
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onAddToCart(_x) {
        return _ref.apply(this, arguments);
      }

      return onAddToCart;
    }(),
    onClose: function onClose() {
      // User closed modal. Here you could forward them to checkout if they had
      // added products (onAddToCart was called before).
    },
    onCheckout: function onCheckout(data) {
      // User clicked the checkout button that is visible on results page
      // after adding one or more products to cart. Redirect to checkout page?

      window.location.href = '//boostlabco.com/checkout';
    },
    onClickProduct: function onClickProduct(product) {
      // To be filled in by BoostLab.
      var win = window.open(product.url, '_blank');
      win.focus();
    }
  };

  reveiveInit(config);
}; /*
    *  Reveive App
    *    Contains the scripts required for the reveive facial recognition app.
    *
    *  Version:
    *    1.0.0 - 2020/11/13
    */

var reveiveInit = function reveiveInit(config) {
  var rv = document.createElement('script');
  rv.src = 'https://d38knilzwtuys1.cloudfront.net/revieve-plugin-v4/revieve-plugin-loader.js';
  rv.charset = 'utf-8';
  rv.type = 'text/javascript';
  rv.async = 'true';
  rv.onload = rv.onreadystatechange = function () {
    var rs = this.readyState;
    if (rs && rs != 'complete' && rs != 'loaded') return;
    Revieve.Init(config, function () {
      // Comment out the below line if you want to open the modal
      // manually when user clicks a certain button or navigates
      // to certain page.
    });
  };
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(rv, s);
};